import { colors } from '../../colors';
var richText = {
  backgroundColor: colors.white,
  h1Color: colors.lead,
  h2Color: colors.lead,
  paraColor: colors.copper,
  anchorColor: colors.copper
};
export default richText;